import { useState } from 'react';
import {
  Paper,
  Table as MuiTable,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material';
import { Green3, PrimaryTitleGray } from '../../../app/theme/tokens/colors';

const RESERVED_FIELDS = new Set([
  'expandPanel',
  'showExpandPanelIcon',
  'addExpandedRow',
  'removeExpandedRow',
]);

const getRowCells = (row) => {
  if (Array.isArray(row)) {
    return row.filter((value) => value !== null);
  }

  return Object.entries(row ?? {})
    .filter(([field, value]) => !RESERVED_FIELDS.has(field) && value !== null)
    .map(([, value]) => value);
};

export const OrderFlowTable = ({
  header,
  data,
  onRowSelection,
  isRowDisabled,
  ariaLabel = 'Dados do pedido',
  minWidth = 650,
}) => {
  const [selectedRowIndex, setSelectedRowIndex] = useState(-1);

  const selectRow = (row, rowIndex) => {
    if (!onRowSelection || isRowDisabled?.(row, rowIndex)) return;

    setSelectedRowIndex(rowIndex);
    onRowSelection(row, rowIndex);
  };

  return (
    <TableContainer
      component={Paper}
      elevation={0}
      sx={{
        border: '1px solid #e6e6e6',
        borderRadius: 1,
        overflowX: 'auto',
      }}
    >
      <MuiTable
        stickyHeader
        size="small"
        aria-label={ariaLabel}
        sx={{ minWidth }}
      >
        <TableHead>
          <TableRow>
            {header.map((column, columnIndex) => (
              <TableCell
                key={columnIndex}
                align="center"
                sx={{
                  backgroundColor: '#767676',
                  color: 'white',
                  fontWeight: 700,
                  whiteSpace: 'nowrap',
                }}
              >
                {column}
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {data.map((row, rowIndex) => {
            const disabled = isRowDisabled?.(row, rowIndex) ?? false;
            const selected = !!onRowSelection && selectedRowIndex === rowIndex;

            return (
              <TableRow
                hover={!disabled}
                key={rowIndex}
                onClick={() => selectRow(row, rowIndex)}
                sx={{
                  cursor: onRowSelection
                    ? disabled
                      ? 'not-allowed'
                      : 'pointer'
                    : 'default',
                  opacity: disabled ? 0.65 : 1,
                  backgroundColor: selected
                    ? `${Green3} !important`
                    : undefined,
                  '& .MuiTableCell-root': {
                    color: selected ? 'white' : PrimaryTitleGray,
                  },
                }}
              >
                {getRowCells(row).map((value, columnIndex) => (
                  <TableCell
                    key={columnIndex}
                    sx={{
                      py: 0.75,
                      verticalAlign: 'middle',
                      whiteSpace:
                        typeof value === 'string' ? 'pre-line' : undefined,
                    }}
                  >
                    {value}
                  </TableCell>
                ))}
              </TableRow>
            );
          })}
        </TableBody>
      </MuiTable>
    </TableContainer>
  );
};
